import { render, staticRenderFns } from "./RsaConfigurazioneAreeListPage.vue?vue&type=template&id=9eda518e"
import script from "./RsaConfigurazioneAreeListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAreeListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports